import { CircularProgress, IconButton, TextField, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import React, { useState } from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import { useMutation } from '@tanstack/react-query'
import SendIcon from '@mui/icons-material/Send'
import { IGame } from '../../../../../../../../../api/types/game'
import { useGlobalError } from '../../../../../../../../../context/GlobalError'
import { ICreateChatMessage } from '../../../../../../../../../api/types/chat'
import { mutationCreateChatMessage } from '../../../../../../../../../api/mutations'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
    },
    chatInputText: {
      width: '100%',
    },
    chatSendButton: {
      margin: '2px',
      padding: '2px',
    },
  })
)

interface Props {
  game: IGame
  npcName: string
  color?: string
  showChatTab?: () => void
}

export const NpcChatMessageInput: React.FC<Props> = ({ game, npcName, color, showChatTab }) => {
  const classes = useStyles()
  const { addError } = useGlobalError()
  const [message, setMessage] = useState<string>('')

  const { mutate: postChatMessage, isLoading: isMutating } = useMutation(
    (newMessage: ICreateChatMessage) => mutationCreateChatMessage(newMessage),
    {
      onError: (err: any) => {
        addError('Nie udało się wysłać wiadomości', err?.status)
      },
    }
  )

  const parseMessage = (msg: string): ICreateChatMessage => {
    msg = `/npc$${npcName}$${color || ''} ${msg.trim()}`
    return {
      game: game.id,
      message: msg,
    }
  }

  const handlePostMessage = () => {
    if (message?.length > 0) {
      const parsed = parseMessage(message)
      postChatMessage(parsed)
      setMessage('')
      showChatTab && showChatTab()
    }
  }

  const handleChatMessageInput = (event: any) => {
    if ((event.code === 'Enter' || event.code === 'NumpadEnter') && !event.shiftKey) {
      event.preventDefault()
      handlePostMessage()
    }
  }

  return (
    <div className={classes.container}>
      <TextField
        variant={'standard'}
        multiline={true}
        className={classes.chatInputText}
        onKeyDown={handleChatMessageInput}
        onChange={e => setMessage(e.target.value)}
        value={message}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {isMutating && <CircularProgress size={20} />}
            </InputAdornment>
          ),
        }}
      />
      <IconButton size="small" className={classes.chatSendButton} onClick={handlePostMessage}>
        <SendIcon />
      </IconButton>
    </div>
  )
}
